import createIcon from '../../createIcon';

/**
 * @component @name AlignHorizontalRight
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjAgMkgyMlYyMkgyMFYyWk0yIDEwSDE4VjdIMlYxMFpNOCAxN0gxOFYxNEg4VjE3WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AlignHorizontalRight = createIcon('AlignHorizontalRight', [
  ['path', { d: 'M20 2H22V22H20V2ZM2 10H18V7H2V10ZM8 17H18V14H8V17Z', key: '1doeoy' }],
]);

export default AlignHorizontalRight;
